import { render, staticRenderFns } from "./PrettyFilename.vue?vue&type=template&id=33b8ad0b&"
import script from "./PrettyFilename.vue?vue&type=script&lang=js&"
export * from "./PrettyFilename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PrettyFilename.vue"
export default component.exports